<template>
  <div id="">
    <el-table
      class="disTable"
      ref="multipleTable"
      :max-height="maxHeight"
      stripe
      :border="false"
      :header-row-style="{
        background: 'none',
        color: '#647196'
      }"
      :header-cell-style="{
        background: '#F1F4F6',
        color: '#3D4042',
        height: '56px',
        fontSize: '16px',
        padding: '0'
      }"
      :row-style="{
        background: 'none',
        height: '56px',
        borderBottom: '1px solid #D9DCDE'
      }"
      :cell-style="{
        background: 'none',
        color: '#3D4042',
        fontSize: '16px',
        borderBottom: '1px solid #D9DCDE'
      }"
      :data="dataList.tableData"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @select-all="selectAll"
      row-key="id"
    >
      <el-table-column v-if="select" type="selection" width="55">
      </el-table-column>
      <el-table-column
        v-if="isShowIndex"
        label="序号"
        type="index"
        width="55"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in dataList.columns"
        :key="index"
        :align="item.align || 'center'"
        :prop="item.prop"
        :label="item.label"
        :show-overflow-tooltip="item.showToolitip || true"
        :filters="item.filters || null"
        :filter-method="item.filters ? filterTag : null"
        :filter-placement="item.filters ? 'bottom-end' : null"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <template v-if="item.slot">
            <slot :name="item.slot" :scope="scope"></slot>
          </template>
          <template v-else>
            <span>{{ scope.row[item.prop] }}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" v-if="isShowPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total,prev, pager, next,sizes,jumper"
        :total="Number(page.total)"
        background
        :page-size="page.size"
        :current-page.sync="page.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :style="{ textAlign: 'right' }"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      default: () => {
        return {
          total: 0,
          size: 10,
          page: 1
        };
      }
    },
    dataList: {
      type: Object,
      default: () => {
        return {
          tableData: [],
          columns: []
        };
      }
    },
    selectedIdOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isShowIndex: {
      type: Boolean,
      default: true
    },
    isShowPagination: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 500
    },
    select: {
      type: Boolean,
      default: false
    },
    delSelected: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    filterTag(value, row) {
      return row.primaryPollutant === value;
    },
    handleCurrentChange(data) {
      this.$emit("handleCurrentChange", data);
    },
    handleSizeChange(data) {
      this.$emit("handleSizeChange", data);
    },
    handleSelectionChange(data) {
      this.$emit("handleSelectionChange", data);
    },
    selectAll(data) {
      this.$emit("selectAll", data);
    },
    updateSelectedItemsOnPageChange() {
      if (!this.dataList.tableData) return;
      // 根据selectedItems筛选当前页面的选中项
      const selectedCurrentPageItems = this.dataList.tableData.filter(item =>
        this.selectedIdOptions.includes(item.taskId)
      );
      console.log(this.selectedIdOptions, 1111111);
      console.log(selectedCurrentPageItems, 1111111);
      // 更新表格的默认选中项
      this.$refs.multipleTable.clearSelection();
      selectedCurrentPageItems.forEach(item =>
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        })
      );
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "odd-row";
      } else if (rowIndex % 2 === 1) {
        return "even-row";
      }
      return "";
    }
  },
  computed: {},
  watch: {
    dataList: {
      handler(val) {
        if (!this.selectedIdOptions.length) return;
        this.updateSelectedItemsOnPageChange();
      },
      deep: true,
      immediate: true
    },
    delSelected: {
      handler(val) {
        if (!val || !Object.keys(val).length) return;
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(val, false);
        });
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-table {
  background: none;
}

.block {
  // position: absolute;
  // right: 56px;
  width: calc(100% - 80px);
  // bottom: 12px;
}

/deep/.el-table::before {
  display: none;
}

/deep/.el-table .el-table__cell,
/deep/.el-table td,
/deep/.el-table th {
  padding: 0;
}
/deep/.el-table .el-table__cell {
  background: #fff !important;
}
/deep/.el-table th.el-table__cell {
  background: rgb(241, 244, 246) !important;
}
/deep/.el-table .even-row,
/deep/.el-table tr:hover,
/deep/.el-table .el-table__body tr.el-table__row:hover,
/deep/.el-table--enable-row-hover .el-table__body tr.even-row:hover > td {
  background: none !important;
}

/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background: none;
  border-radius: 4px;
  border: 1px solid #dddfe8;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: 272a31;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: none;
  border-radius: 4px;
  border: 1px solid #3666ea;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #3666ea;
}

/deep/.el-pagination span:not([class*="suffix"]) {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #272a31;
}

/deep/.el-table {
  .el-table__body-wrapper::-webkit-scrollbar {
    display: block !important;
  }
}

/deep/.el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/table/index2.vue